module.exports = __webpack_public_path__ + "img/lock_answers_lesson.ea4b4980.svg";